export default "__VITE_ASSET__Cx__VwRU__"